
const local_key = "baashyaam-telecaller-user";

/**
 * Load user data from local storage
 * @returns {Object|undefined} The user data or undefined if not found
 */
export const loadLocalState = () => {
    try {
        const serializedState = localStorage.getItem(local_key);
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        console.error("Error loading user from local storage:", err);
        return undefined;
    }
};

/**
 * Save user data to local storage, merging with existing data
 * @param {Object} state - The user state to save
 */
export const saveLocalState = (state) => {
    try {
        const data = loadLocalState() || {};
        const serializedState = JSON.stringify({ ...data, ...state });
        localStorage.setItem(local_key, serializedState);
    } catch (err) {
        console.error("Error saving user to local storage:", err);
    }
};

/**
 * Delete user data from local storage
 */
export const deleteLocalUser = () => {
    try {
        localStorage.removeItem(local_key);
    } catch (err) {
        console.error("Error deleting user from local storage:", err);
    }
};

/**
 * Save head office location
 * @param {{ latitude: number, longitude: number }} location
 */
export const saveHeadOfficeLocation = (location) => {
    if (!location || location.latitude == null || location.longitude == null) return;
    saveLocalState({ headOfficeLocation: location });
};

/**
 * Get head office location
 * @returns {{ latitude: number, longitude: number } | undefined}
 */
export const getHeadOfficeLocation = () => {
    const data = loadLocalState();
    return data?.headOfficeLocation;
};

/**
 * Save user's current location
 * @param {{ latitude: number, longitude: number }} location
 */
export const saveUserCurrentLocation = (location) => {
    if (!location || location.latitude == null || location.longitude == null) return;
    saveLocalState({ currentLocation: location });
};

/**
 * Get user's current location
 * @returns {{ latitude: number, longitude: number } | undefined}
 */
export const getUserCurrentLocation = () => {
    const data = loadLocalState();
    return data?.currentLocation;
};






















